export default __webpack_public_path__ + "static/assets/med_pill_round_flat_L0_solid_l_01_f.1098e92d.png";